import React, {Component} from 'react';
import axios from 'axios';
import Transition from 'react-transition-group/Transition';
import { StyleSheet, css } from 'aphrodite';


class Contact extends Component {
  state ={
    in: false,
    email: {
      emailInput:'',
      subjectInput: '',
      messageInput: ''
    }
  }

  componentDidMount() {
    this.setState({
      in: true
    })
  }

  sendemail = (event) => {
    event.preventDefault();
    const email = this.state.email;
    console.log(email);
    axios.post('/api/email', email )
      .then(result => {
        const contactForm = document.getElementById('contactForm');
        contactForm.reset();
        console.log(result)
      })
      .catch(err => console.log(err))
  }

  getEmail = (event) =>{
    event.preventDefault();
    let target = event.target;
    let info = target.value;
    const id = event.target.id;
    let state = this.state
    state.email[id] = info;
    this.setState(state.email, ()=>{
      //console.log(this.state[id])
    });
  }

  render(){
    const defaultStyle = {
      transition: 'opacity 750ms ease-in-out',
      opacity: 0,
    }
    const transitionStyles = {
        entering: { opacity: 0 },
        entered: { opacity: 1 }
    }
    // const formStyle = {
    //   fontFamily:"'Lato', sans-serif",
    //   marginTop: '10vh'
    // }

    const formTitleStyle = {
      fontFamily: "'Squada One', sans-serif",
      color: '#f5b779'
    }

    return(
      <Transition in={this.state.in} timeout={500}>
        {
          (state) => {
            return (
              <div className={`row justify-content-center ${css(styles.formStyle)}`} style={{...defaultStyle, ...transitionStyles[state]}}>
                <form className="col-10" id="contactForm">
                  <div className="form-group text-left">
                    <label htmlFor="emailInput" style={formTitleStyle}><h3>Email address</h3></label>
                    <input type="email" className="form-control" id="emailInput" placeholder="name@example.com" onChange={this.getEmail}/>
                  </div>
                  <div className="form-group text-left">
                    <label htmlFor="subjectInput" style={formTitleStyle}><h3>Subject</h3></label>
                    <input type="text" className="form-control" id="subjectInput" placeholder="subject..." onChange={this.getEmail}/>
                  </div>
                  <div className="form-group text-left">
                    <label htmlFor="messageInput" style={formTitleStyle}><h3>Message</h3></label>
                    <textarea className="form-control" id="messageInput" rows="3" style={{height: "25vh"}} onChange={this.getEmail}></textarea>
                  </div>
                  <div className="form-group text-left">
                    <button className={`btn btn-lg col-6 col-md-4 ${css(styles.formButton)}`} style={formTitleStyle} onClick={this.sendemail}>Contact me</button>
                  </div>
                </form>
              </div>
            )
          }
        }
      </Transition>
    )
  }
}

const styles = StyleSheet.create({
  formStyle: {
    fontFamily:"'Lato', sans-serif",
    marginTop: '5vh',
    overflow: 'scroll',
    '::-webkit-scrollbar': {
      display: 'none'
    }
  },
  formTitleStyle: {
    fontFamily: "'Squada One', sans-serif",
    color: '#f5b779'
  },
  formButton: {
    background: '#f5b779',
    color: '#2b2b2f',
    ':active': {
      background: '#ff9c23'
    }
  }
})

export default Contact



// WEBPACK FOOTER //
// ./src/components/contact/contact.js